import styles from "./EmbeddedHeader.module.scss";
import PageSelector from "./PageSelector.tsx";
import Logo from "./Logo.tsx";
import ThreeDot from "./ThreeDot.tsx";
import { clsx } from "clsx";
import { getEmbeddedPortalDataAttr } from "./utils.ts";

export default function EmbeddedHeader({ className }: { className?: string }) {
  return (
    <header className={clsx(styles.header, className)}>
      <Logo className={styles.logo} />
      <div className={styles.separator} />
      <PageSelector />
      <div className={styles.rightContent}>
        <div {...getEmbeddedPortalDataAttr()}></div>
        <ThreeDot />
      </div>
    </header>
  );
}
